import { css } from '@emotion/react'
import skyThemeRaw from '@skycell-ag/theme'

import { SkyTheme } from 'App/ThemeProvider/theme.types'
import { skyCenterPrimaryPalette } from 'App/ThemeProvider/conts'

const skyTheme = skyThemeRaw as unknown as SkyTheme

const boxShadow = '0px 1px 3px #00000033'
const stepBorderBackgroud = '#61C6E92E'

const stepTextPaddingT = css` padding: 20px `
const stepElementPaddingT = css` padding: 10px `
const messageTextT = css`
    color: #00000099;
    letter-spacing: 1.11px;
    `

const custom = {
    border: css` border: 1px solid ${skyTheme.palette.secondary[50]} `,
    boxShadow: css` box-shadow: ${boxShadow} `,
    boxShadowRadius: css`
        border-radius: ${skyTheme.shape.borderRadius};
        box-shadow: ${boxShadow};
    `,
    messageText: messageTextT,
    dialogTitle: css`
        background: ${stepBorderBackgroud};
        border-radius: 10px;
        color: ${skyTheme.palette.secondary[600]};
    `,
    stepBorder: css`
        border-style: solid;
        border-color: ${stepBorderBackgroud};
        border-width: 10px;
    `,
    button: css`
        height: 59px;
        width: 153px;
        white-space: nowrap;
        background-color: ${skyTheme.palette.primary[200]};
        color: ${skyTheme.palette?.common.white};
        letter-spacing: 2.14px;
        font: normal normal 400 ${skyTheme.typography.h3.fontSize}px/${skyTheme.typography.h3.lineHeight} Roboto;
        border-radius: ${skyTheme.shape?.borderRadius};
        box-shadow: ${boxShadow};
        &:disabled {
            background-color: ${skyTheme.palette.primary[200]};
            color: rgba(0, 0, 0, 0.26);
        },
        &:disabled:hover {
            background-color: ${skyTheme.palette.primary[200]};
            color: rgba(0, 0, 0, 0.26);
        },
        &:hover {
            background-color: ${skyTheme.palette.primary[200]};
            color: ${skyTheme.palette?.common.white};
    `,
    stepTextPadding: stepTextPaddingT,
    stepElementPadding: stepElementPaddingT,
    stepText: css`
        ${messageTextT};
        ${stepTextPaddingT};
    `,
    dashBoardRoot: css` padding: 30px 90px `,
    mandatoryStepText: css` background: ${skyCenterPrimaryPalette.unAnsweredMandatory} `,
    mandatoryStepBorder: css` border-color: ${skyCenterPrimaryPalette.unAnsweredMandatory} `,
    optionalStepText: css` background: ${skyTheme.palette?.secondary[200]} `,
    optionalStepBorder: css` border-color: ${skyTheme.palette?.secondary[200]} `,
}

export default custom
